import { createRmAll } from './rm-all.js';
import last from 'it-last';
import { configure } from '../lib/configure.js';
export const createRm = config => {
  const all = createRmAll(config);
  return configure(() => {
    async function rm(path, options = {}) {
      return last(all([{
          path,
          ...options
        }], options));
    }
    return rm;
  })(config);
};